import { Component, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import {
  MatLegacyDialogModule as MatDialogModule,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SafeHtmlPipe } from '@cutting/main/shared/pipes/safe-html.pipe';

@Component({
  selector: 'cutting-map-viewer-dialog',
  templateUrl: './map-viewer-dialog.component.html',
  styleUrls: ['./map-viewer-dialog.component.scss'],
  standalone: true,
  imports: [SafeHtmlPipe, MatIconModule, MatToolbarModule, MatDialogModule, MatButtonModule],
  encapsulation: ViewEncapsulation.None,
})
export class MapViewerDialogComponent {
  mapSvg = '';

  constructor(public dialogRef: MatDialogRef<MapViewerDialogComponent>) {}
}
